import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'hs-generic-delete-confirmation-modal',
  templateUrl: './generic-delete-confirmation-modal.component.html',
  styleUrls: [],
})
export class GenericDeleteConfirmationModalComponent {
  constructor(public activeModal: NgbActiveModal) {}

  @Input()
  deleteConfirmationText: string | null =
    'Are you sure that you want to delete?'

  @Input()
  deleteButtonText: string | null = 'Delete'

  delete() {
    this.activeModal.close()
  }
}
